import type { ColumnConfigSliceShape } from './column-config-slice'
import type { FiledsSliceShape } from './fields-slice'
import type { MetaSliceShape } from './meta-slice'
import type { PresetSliceShape } from './preset-slice'
import type { TableSliceShape } from './table-slice'

import { use } from 'react'
import { useStore as useZustandStore } from 'zustand'
import { createStore } from 'zustand/vanilla'

import { DatasheetContext } from '../context'
import { createColumnConfigSlice } from './column-config-slice'
import { createFieldsSlice } from './fields-slice'
import { createMetaSlice } from './meta-slice'
import { createPresetSlice } from './preset-slice'
import { createLayoutSlice } from './table-slice'

export type Shape = TableSliceShape &
	ColumnConfigSliceShape &
	FiledsSliceShape &
	PresetSliceShape &
	MetaSliceShape
export const createDatasheetStore = (initialState?: Partial<Shape>) =>
	createStore<Shape>()((...args) => ({
		...createMetaSlice(...args),
		...createLayoutSlice(...args),
		...createColumnConfigSlice(...args),
		...createFieldsSlice(...args),
		...createPresetSlice(...args),
		...initialState,
	}))
export function useStore<T>(selector: (state: Shape) => T): T {
	const store = use(DatasheetContext)
	if (!store) throw new Error('Missing DatasheetContext in the tree')

	return useZustandStore(store, selector)
}

export const useDatasheetStore = () => use(DatasheetContext)!
